import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { IconErrorCircle } from "../../../utils/Icons";

const ModalError = (props) => {
  // Translation
  const { t } = useTranslation();

  return (
    <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <IconErrorCircle width="65px" height="65px" fill="#fb725a" />
        <p className="mt-30">{t("home.exchenge.modalError.title")}</p>
      </Modal.Body>
    </Modal>
  );
};

export default ModalError;
